import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { getTypeBadge, getDaysUntil, getDayOfWeek } from './mesJoursFeriesHelpers';

const MesJoursFeriesUpcomingHolidays = ({ upcomingHolidays }) => {
  const { t, i18n } = useTranslation();

  if (upcomingHolidays.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          {t("myHolidaysComponents.upcoming.title")}
        </CardTitle>
        <CardDescription>{t("myHolidaysComponents.upcoming.description")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {upcomingHolidays.slice(0, 5).map((holiday) => {
            const daysUntil = getDaysUntil(holiday.date);
            const isToday = daysUntil === 0;
            const isTomorrow = daysUntil === 1;

            return (
              <div
                key={holiday.id}
                className={`flex items-center justify-between p-3 rounded-lg border ${
                  isToday ? 'bg-green-950/20 border-green-900/40'
                  : isTomorrow ? 'bg-primary/5 border-primary/30'
                  : 'bg-muted/50 border-border'
                }`}
              >
                <div className="flex items-start gap-3 flex-1">
                  <div className={`flex-shrink-0 w-12 h-12 rounded-lg flex flex-col items-center justify-center ${
                    isToday ? 'bg-green-950/40' : isTomorrow ? 'bg-primary/10' : 'bg-muted'
                  }`}>
                    <span className={`text-lg font-bold ${isToday ? 'text-green-400' : isTomorrow ? 'text-primary' : 'text-foreground'}`}>
                      {new Date(holiday.date).getDate()}
                    </span>
                    <span className={`text-xs ${isToday ? 'text-green-400' : isTomorrow ? 'text-primary' : 'text-muted-foreground'}`}>
                      {new Date(holiday.date).toLocaleDateString(i18n.language, { month: 'short' }).toUpperCase()}
                    </span>
                  </div>
                  <div className="flex-1">
                    <p className="font-medium">{holiday.name}</p>
                    <p className="text-sm text-muted-foreground capitalize">{getDayOfWeek(holiday.date, i18n.language)}</p>
                    {holiday.description && (
                      <p className="text-xs text-muted-foreground mt-1">{holiday.description}</p>
                    )}
                  </div>
                </div>
                <div className="flex flex-col items-end gap-2">
                  {getTypeBadge(holiday.type, t)}
                  {isToday ? (
                    <Badge className="bg-green-500">{t("holidayCommon.today")}</Badge>
                  ) : isTomorrow ? (
                    <Badge className="bg-primary">{t("holidayCommon.tomorrow")}</Badge>
                  ) : (
                    <Badge variant="outline">{t("holidayCommon.inDays", { count: daysUntil, suffix: daysUntil > 1 ? "s" : "" })}</Badge>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default MesJoursFeriesUpcomingHolidays;
